import { toast } from '@hive/component';
import {
  type DialogComponentProps,
  type GLOBAL_DIALOG_SCHEMA,
} from '@hive/core/modules/dialogs';
import { useI18n } from '@hive/i18n';
import { useLayoutEffect, useRef } from 'react';

export const ImportWorkspaceDialog = ({
  close,
}: DialogComponentProps<GLOBAL_DIALOG_SCHEMA['import-workspace']>) => {
  const effectRef = useRef(false);
  const t = useI18n();

  useLayoutEffect(() => {
    if (effectRef.current) {
      return;
    }
    effectRef.current = true;

    // Local workspace import is disabled - cloud workspaces only
    toast(
      t['com.hive.workspace.cloud.description']?.() ||
        'Please use cloud workspaces'
    );
    close();
  }, [close, t]);

  return null;
};
